import {useState, type ReactNode} from 'react'
import type {GroupHeaderFn, ToolGroupBase} from './types'
import {NewToolHeader} from '../tool/NewToolHeader'
import styles from './ToolGroupRenderer.module.css'
import toolStyles from '../tool/Tool.module.css'

type ToolGroupRendererProps = {
  group: ToolGroupBase
  groupHeaderFn: GroupHeaderFn
  children: ReactNode
}

export function ToolGroupRenderer({group, groupHeaderFn, children}: ToolGroupRendererProps) {
  const headerData = groupHeaderFn(group)
  // Groups with 30+ tools start collapsed to avoid overwhelming the UI
  const [isCollapsed, setIsCollapsed] = useState(group.count >= 30)

  const handleToggle = () => {
    setIsCollapsed(prev => !prev)
  }

  return (
    <div className={toolStyles.toolContainer}>
      <div className={styles.toolGroupHeader}>
        <NewToolHeader
          title={headerData.title}
          leadingVisual={headerData.leadingVisual}
          isError={false}
          isPending={false}
          isCollapsed={isCollapsed}
          isGroupHeader
          onToggle={handleToggle}
        />
      </div>
      {!isCollapsed && (
        <div className={styles.toolGroupContentWrapper}>
          <div className={styles.connectorLine} />
          <div className={styles.toolGroupContent}>{children}</div>
        </div>
      )}
    </div>
  )
}
